module.exports = __webpack_public_path__ + "img/IMG_6839.01fce618.webp";